import cls from "./ResultStageCard.module.scss";

export default function ResultStageCard({ turn, players, penaltyView }) {
  const answerSelection = turn?.answerPlayerSelection || "-";
  const guessSelection = turn?.guessPlayerSelection || "-";
  const matched = answerSelection === guessSelection;

  return (
    <section className={cls.card}>
      <div className={cls.glowPink} />
      <div className={cls.glowBlue} />

      <div className={cls.header}>
        <p className={cls.kicker}>TURN RESULT</p>
        <h3 className={cls.title}>
          {matched ? "Perfect Match" : "Missed Guess"}
        </h3>
        <p className={cls.subtitle}>
          {matched
            ? "The guess matched the hidden answer."
            : "The guess did not match the hidden answer."}
        </p>
      </div>

      <div className={cls.resultBadgeWrap}>
        <span className={`${cls.resultBadge} ${matched ? cls.win : cls.lose}`}>
          {matched ? "MATCHED" : "NOT MATCHED"}
        </span>
      </div>

      <div className={cls.playerGrid}>
        <article className={cls.playerCard}>
          <span className={cls.playerLabel}>ANSWER PLAYER</span>
          <strong className={cls.playerName}>
            {players?.answerPlayer?.displayName || "-"}
          </strong>
          <span className={cls.choiceTag}>Choice: {answerSelection}</span>
        </article>

        <article className={cls.playerCard}>
          <span className={cls.playerLabel}>GUESS PLAYER</span>
          <strong className={cls.playerName}>
            {players?.guessPlayer?.displayName || "-"}
          </strong>
          <span className={cls.choiceTag}>Choice: {guessSelection}</span>
        </article>
      </div>

      <p className={cls.subtitle}>
        Penalty phase will start after admin opens settlement.
      </p>

      <div className={cls.summaryGrid}>
        <article className={cls.summaryCard}>
          <span className={cls.summaryLabel}>WINNER</span>
          <strong className={cls.summaryValue}>
            {players?.winnerPlayer?.displayName || "-"}
          </strong>
        </article>

        <article className={cls.summaryCard}>
          <span className={cls.summaryLabel}>LOSER</span>
          <strong className={cls.summaryValue}>
            {players?.loserPlayer?.displayName || "-"}
          </strong>
        </article>
      </div>
      <div className={cls.resultBadgeWrap}>
        <span className={cls.resultBadge}>
          Penalty:{" "}
          {turn?.penaltyState || penaltyView?.turn?.penaltyState || "pending"}
        </span>
      </div>
    </section>
  );
}
